import { EMPTY_CODES } from "../threePsCodes.constants";
import { ThreePsStore } from "./threePsTypes";

export const selectVendors = (state: ThreePsStore) => state.vendors;
export const selectSelectedVendor = (state: ThreePsStore) => state.selectedVendor;
export const selectTotalThreePsCodes = (state: ThreePsStore) => {
    if (!state.selectedVendor) return 0;
    return state.codesPageMetaByVendor[state.selectedVendor]?.total ?? state.totalThreePsCodes;
};
export const selectIsEditMode = (state: ThreePsStore) => state.isEditMode;
export const selectIsVendorsLoading = (state: ThreePsStore) => state.isVendorLoading;
export const selectIsCodesLoading = (state: ThreePsStore) => state.isCodesLoading;
export const selectVendorsError = (state: ThreePsStore) => state.vendorsError;
export const selectPageSize = (state: ThreePsStore) => state.pageSize;
export const selectPageIndex = (state: ThreePsStore) => state.pageIndex;

export const selectSelectedVendorCodes = (state: ThreePsStore) => {
    if(!state.selectedVendor) return EMPTY_CODES;
    return state.codesByVendor[state.selectedVendor] ?? EMPTY_CODES;
}